<template>
    <div>
    <h1 class="text-center title__gestion">Lista de tareas</h1>
    <hr />

    <!-- //===TABLA====== -->
    <v-card  class="mx-auto mt-100" color="transparent" elevation="0">
       

        <template v-slot:text>
        <v-text-field
            v-model="search"
            label="Buscar"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            single-line ></v-text-field>
        </template>

        <v-data-table :headers="headers" :items="desserts" :search="search">
            <template v-slot:item="props">
                <tr>
                    <td>{{ props.item.placa }}</td>
                    <td>{{ props.item.usuario }}</td>
                    
                    <!-- Campo Piso como Checkbox -->
                    <td>
                        <v-checkbox
                            v-model="props.item.piso"
                            :value="true"
                            :input-value="props.item.piso"
                            :disabled="true">
                            
                        </v-checkbox>
                    </td>

                    <!-- Campo Cocina como Checkbox -->
                    <td>
                        <v-checkbox
                            v-model="props.item.cocina"
                            :value="true"
                            :input-value="props.item.cocina"
                            :disabled="true">
                        </v-checkbox>
                    </td>

                    <!-- Campo Baño como Checkbox -->
                    <td>
                        <v-checkbox
                            v-model="props.item.baño"
                            :value="true"
                            :input-value="props.item.baño"
                            :disabled="true">
                        </v-checkbox>
                    </td>

                    <td>{{ props.item.comentarios }}</td>

                </tr>
            </template>
        </v-data-table>
    </v-card>
    

    </div>
</template>

<script>
import axios from "axios";

export default {
    name:"SamTarea",
data() {
    return {
        search: '',

        mostrar_error: false,
        // errorApi:'Algo salio mal. Agrega un catalogo de forma de pago diferente',
        timeout: 2000,

        headers: [
            { align: 'start', key: 'placa', sortable: false, title: 'Modelo' },
            // { key: 'placa', title: 'Modelo' },
            { key: 'usuario', title: 'Usuario' },
            { key: 'piso', title: 'Piso' },  
            { key: 'cocina', title: 'Cocina' },  
            { key: 'baño', title: 'Baño' },  
            { key: 'comentarios', title: 'Comentarios' },
            
        ],


        desserts: [],

        usuarios: [],   // Aquí guardaremos los usuarios 

        modelos: [],




    listaTareas: {  
        id_usuario: null,  // Debe ser null para evitar problemas
        id_placa: null,    // Asegurar que `placa` es `id_placa`
        // placa: null,    // Asegurar que `placa` es `id_placa`
        piso: false,
        cocina: false,
        baño: false,
        comentarios: '',
    },
    };
},
mounted() {
    this.listar();  // Llamamos a listar cuando el componente se monta
},
methods: {
    async listar() {
try {
    const res = await axios.get('https://api.rf8income.com.mx/api/mostrarListaTareas');

    // Filtramos los datos para mostrar solo las tareas de la persona con id_usuario 3
    this.desserts = res.data
        .filter(item => item.id_usuario === 1)  // Filtra los datos con id_usuario igual a 3
        .map(item => ({
            ...item,
            piso: item.piso === 1,   // Convertimos 1 a true y 0 a false
            cocina: item.cocina === 1,
            baño: item.baño === 1
        }));

} catch (error) {
    console.error('Error al cargar las placas:', error);
    this.mostrar_error = true;
    this.errorApi = 'Error al cargar los modelos.';
}
}
,
    verificarSeleccion() {
            console.log("Usuario seleccionado:", this.listaTareas.usuario);
    },
    
    created() {
    this.listar();
    },
}
};
</script>